module.exports = __webpack_public_path__ + "static/media/1POLICY12.b840d34b.jpg";